











































































import {Component, Mixins, Watch} from "vue-property-decorator";
import {mapGetters, mapMutations} from "vuex";
import Page from "@/components/for-page-grid/Page.vue";
import XButton from "@/components/SimpleButton.vue";
import WelcomeCard from "@/components/for-my-contracts/WelcomeCard.vue";
import ContractTable from "@/components/for-my-contracts/ContractTable.vue";
import XSlider from "@/components/SimpleSlider.vue";
import ContractAddingForm
  from "@/components/for-my-contracts/ContractAddingForm.vue";
import ContractRemovingDialog
  from "@/components/for-my-contracts/ContractRemovingDialog.vue";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import XDropdownWithRadioButtons
  from "@/components/hoc/DropdownWithRadioButtons.vue";

@Component({
  components: {
    XDropdownWithRadioButtons,
    Page,
    XButton,
    WelcomeCard,
    ContractTable,
    XSlider,
    ContractAddingForm,
    ContractRemovingDialog,
  },
  computed: {
    ...mapGetters("contract", { useContract: "useContract" }),
    ...mapGetters("contracts", {
      sortedContractsByOrganization: "sortedContractsByOrganization",
      balanceListByContracts: "balanceList",
    }),
  },
  methods: {
    ...mapMutations("error", { setMessage: "setMessage" }),
  },
})
class MyContracts extends Mixins(AppApiMixin) {
  dropdownGroupCssClasses = [
    "tabs__dropdown-group",
    "box",
    "box_shadow_initial",
    "px-6",
    "py-2",
    "rounded-lg",
    "white",
  ];

  activityDropdownItems = [
    { label: "Все", useDivider: true },
    "Открытые",
    "Закрытые",
  ];
  selectedActivity = 1;

  showContractAddingForm = false;

  showContractRemovingDialog = false;
  contractIdForRemoving = -1;

  contractItems = [];

  public mounted() {
    // отключим старые ошибки
    this.setMessage(null);

    this.prepareContractItems();
    this.enterApp(true);
  }

  public closeContractRemovingDialog() {
    this.showContractRemovingDialog = false;
    this.contractIdForRemoving = -1;
  }

  public get activityDropdownActivatorText(): string {
    const textStarts = ["Все", "Открытые", "Закрытые"];

    return `${textStarts[this.selectedActivity]} договоры`;
  }

  prepareContractItems() {
    let contractItems = [];
    if (this.sortedContractsByOrganization === null) {
      return;
    }
    this.sortedContractsByOrganization.forEach((contractItem) => {
      let contractList = [];
      contractItem.contractList.forEach((contractListItem) => {
        contractList.push({ ...contractListItem });
      });
      contractItems.push({...contractItem, contractList: contractList });
    });
    this.contractItems = contractItems.filter((contract) => {
      if (this.selectedActivity === 1) {
        let contractList = [ ...contract.contractList ];
        contract.contractList = contractList.filter((item) => item.закрыт === 0);
      }
      if (this.selectedActivity === 2) {
        let contractList = [ ...contract.contractList ];
        contract.contractList = contractList.filter((item) => item.закрыт === 1);
      }
      return contract.contractList.length > 0;
    });
  }

  @Watch("selectedActivity")
  selectedActivityChanged() {
    this.prepareContractItems();
  }

  @Watch("sortedContractsByOrganization")
  sortedContractsByOrganizationChanged() {
    this.prepareContractItems();
  }
}

export default MyContracts;
